import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const getCampaignTask = (taskId) =>
  apiActionCreator({
    'endpoint': `/campaing/task/${taskId}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_CAMPAIGN_TASK,
      ActionTypes.FETCHED_CAMPAIGN_TASK,
      [
        ActionTypes.FETCHED_CAMPAIGN_TASK_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });


export const removeElementFromTasks = (tasksArray) =>
  apiActionCreator({
    'endpoint': '/campaing/task',
    'authenticated': true,
    'types': [
      ActionTypes.REMOVING_ELEMENT_FOR_CAMPAIGN_TASKS,
      [
        ActionTypes.REMOVED_ELEMENT_FOR_CAMPAIGN_TASKS,
        MessageActions.addMessageBoxInfo('Registro de trabajo eliminado con exito'),
      ],
      [
        ActionTypes.REMOVED_ELEMENT_FOR_CAMPAIGN_TASKS_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'contentType': 'application/json',
    'method': 'DELETE',
    'data': {tasksArray},
  });

export const addElementToTasks = (task) =>
  apiActionCreator({
    'endpoint': '/campaing/task',
    'authenticated': true,
    'types': [
      ActionTypes.ADDING_ELEMENT_FOR_CAMPAIGN_TASKS,
      [
        ActionTypes.ADDED_ELEMENT_FOR_CAMPAIGN_TASKS,
        MessageActions.addMessageBoxInfo('Registro trabajo agregado con exito'),
      ],
      [
        ActionTypes.ADDED_ELEMENT_FOR_CAMPAIGN_TASKS_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'contentType': 'application/json',
    'method': 'POST',
    'data': task,
  });
